
import React, { } from 'react';
import './menuLink.css';



const MenuLink = ({ src, linkName }) => {

  return (
    <>
      <div className="container_menu_link" >
        <img src={src} alt="kard" className="img_menuLink" />
        <div className="container_menu_link_text">{linkName}</div>
      </div>

    </>

  )
}

export default MenuLink;